import React from 'react';
import BorderCountry from './BorderCountry';

class Details extends React.Component {
  render() {
    const country = this.props.country;
    const theme = this.props.theme;
    const formattedPopulation = Intl.NumberFormat('tr-TR').format(country.population);
    return (
      theme ?
        <div className="mt-10 flex flex-col md:mt-6 lg:flex-row lg:justify-evenly lg:mt-12">
          <div className="w-full h-40 sm:h-56 md:h-64 lg:w-1/3">
            <img src={country.flag} alt="Country flag" className="w-full h-full rounded-sm" />
          </div>
          <div className="flex flex-col lg:w-1/2">
            <h1 className="text-lg font-bold mt-10 md:text-xl lg:text-2xl lg:mt-0"> {country.name} </h1>
            <div className="flex flex-col lg:flex-row">
              <div className="flex flex-col lg:mr-16">
                <div className="flex flex-start mt-4 lg:mt-4">
                  <h6 className="text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Native Name:</h6>
                  <h6 className="text-sm sm:text-base md:text-lg lg:text-sm"> {country.nativeName} </h6>
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Population:</h6>
                  <h6 className="text-sm sm:text-base md:text-lg lg:text-sm"> {formattedPopulation} </h6>
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Region:</h6>
                  <h6 className="text-sm sm:text-base md:text-lg lg:text-sm"> {country.region} </h6>
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Sub Region:</h6>
                  <h6 className="text-sm sm:text-base md:text-lg lg:text-sm"> {country.subregion} </h6>
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Capital:</h6>
                  <h6 className="text-sm sm:text-base md:text-lg lg:text-sm"> {country.capital} </h6>
                </div>
              </div>
              <div className="flex flex-col">
                <div className="flex flex-start mt-8 lg:mt-4">
                  <h6 className="text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Top Level Domain:</h6>
                  <h6 className="text-sm sm:text-base md:text-lg lg:text-sm"> {country.topLevelDomain} </h6>
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Currencies:</h6>
                  {
                    country.currencies.map(currency => (
                      <h6 key={currency.name} className="text-sm sm:text-base md:text-lg lg:text-sm"> {currency.name} </h6>
                    ))
                  }
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Languages:</h6>
                  {
                    country.languages.map((language, index) => (
                      <h6 key={language.name} className="text-sm sm:text-base md:text-lg lg:text-sm">
                        {language.name}{index < country.languages.length - 1 ? ',\u00A0' : ''}
                      </h6>
                    ))
                  }
                </div>
              </div>
            </div>
            <h6 className="text-base font-medium mr-2 mt-8 sm:text-base md:text-lg lg:text-sm">Border Countries:</h6>
            <div className="flex flex-wrap mt-2">
              {
                country.borders.map(border => (
                  <BorderCountry key={border} border={border} theme={theme} />
                ))
              }
            </div>
          </div>
        </div>
        :
        <div className="mt-10 flex flex-col md:mt-6 lg:flex-row lg:justify-evenly lg:mt-12">
          <div className="w-full h-40 sm:h-56 md:h-64 lg:w-1/3">
            <img src={country.flag} alt="Country flag" className="w-full h-full rounded-sm" />
          </div>
          <div className="flex flex-col lg:w-1/2">
            <h1 className="text-gray-400 text-lg font-bold mt-10 lg:mt-0 md:text-xl lg:text-2xl"> {country.name} </h1>
            <div className="flex flex-col lg:flex-row">
              <div className="flex flex-col lg:mr-16">
                <div className="flex flex-start mt-4 lg:mt-4">
                  <h6 className="text-gray-400 text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Native Name:</h6>
                  <h6 className="text-gray-400 text-sm sm:text-base md:text-lg lg:text-sm"> {country.nativeName} </h6>
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-gray-400 text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Population:</h6>
                  <h6 className="text-gray-400 text-sm sm:text-base md:text-lg lg:text-sm"> {formattedPopulation} </h6>
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-gray-400 text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Region:</h6>
                  <h6 className="text-gray-400 text-sm sm:text-base md:text-lg lg:text-sm"> {country.region} </h6>
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-gray-400 text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Sub Region:</h6>
                  <h6 className="text-gray-400 text-sm sm:text-base md:text-lg lg:text-sm"> {country.subregion} </h6>
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-gray-400 text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Capital:</h6>
                  <h6 className="text-gray-400 text-sm sm:text-base md:text-lg lg:text-sm"> {country.capital} </h6>
                </div>
              </div>
              <div className="flex flex-col">
                <div className="flex flex-start mt-8 lg:mt-4">
                  <h6 className="text-gray-400 text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Top Level Domain:</h6>
                  <h6 className="text-gray-400 text-sm sm:text-base md:text-lg lg:text-sm"> {country.topLevelDomain} </h6>
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-gray-400 text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Currencies:</h6>
                  {
                    country.currencies.map(currency => (
                      <h6 key={currency.name} className="text-gray-400 text-sm sm:text-base md:text-lg lg:text-sm"> {currency.name} </h6>
                    ))
                  }
                </div>
                <div className="flex flex-start mt-2">
                  <h6 className="text-gray-400 text-sm font-medium mr-2 sm:text-base md:text-lg lg:text-sm">Languages:</h6>
                  {
                    country.languages.map((language, index) => (
                      <h6 key={language.name} className="text-gray-400 text-sm sm:text-base md:text-lg lg:text-sm">
                        {language.name}{index < country.languages.length - 1 ? ',\u00A0' : ''}
                      </h6>
                    ))
                  }
                </div>
              </div>
            </div>
            <h6 className="text-gray-400 text-base font-medium mr-2 mt-8 sm:text-base md:text-lg lg:text-sm">Border Countries:</h6>
            <div className="flex flex-wrap mt-2">
              {
                country.borders.map(border => (
                  <BorderCountry key={border} border={border} theme={theme} />
                ))
              }
            </div>
          </div>
        </div>
    );
  }
}

export default Details;